import React, { Children } from 'react'

import './Card.css';

export function Card(props) {


	let className = ['card']
	if(props.shadow) className.push(`shadow-${props.shadow}`) 
	if(props.target) className.push(`${props.target}`) 
	if(props.className) className.push(`${props.className}`) 


	// Generate String format : ClassName
	className = className.join(' ')

	return (
		<div 
			className={className}
			>{props.children}</div>
	)
}
